/**
 * Referrals feature auto-registration and exports
 *
 * This module automatically registers the referrals feature when imported,
 * making it work seamlessly with both static and dynamic imports.
 */

import { autoRegisterFeature } from '@store/features/factory';

import { referralsFeature } from './store/feature';

// Auto-register the feature when this module is imported
autoRegisterFeature(referralsFeature);

// Export store (all store-related exports)
export * from './store';

// Export components
export * from './components';

// Export types
export * from './types';

// Export utils
export * from './utils';
